import React, { useEffect } from "react";

import Main from '../components/Home/Main'
import PlatformFeatures from "../components/Home/PlatformFeatures";
import SafetyFunds from "../components/Home/SafetyFunds";
import PortfolioManagment from "../components/Home/PortfolioManagment";

function Home () {
 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    return(
        <div className="relative overflow-hidden mt-[60px]">
            <Main/>
            <PlatformFeatures/>
            <SafetyFunds/>
            <PortfolioManagment/>
        </div>
    );
}

export default Home;